
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/integrations",
      function () {
        return require("private-next-pages/resources/integrations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/integrations"])
      });
    }
  